import { FontWeight } from '@pasteltech/theme-provider'
import { memo } from 'react'
import styled from 'styled-components'
import { DeepNullable } from '../../utilities'

const Value = styled.div`
  color: ${({ theme }) => theme.colors.text.high};
  text-align: center;
  font-size: ${({ theme }) => theme.sizes.fontSize.heading2}px;
  font-weight: ${FontWeight.bold};
`
const Name = styled.div`
  color: ${({ theme }) => theme.colors.text.high};
  font-size: ${({ theme }) => theme.sizes.fontSize.title}px;
  font-weight: ${FontWeight.bold};
`
const Description = styled.div`
  color: ${({ theme }) => theme.colors.text.high};
  font-size: ${({ theme }) => theme.sizes.fontSize.button}px;
  font-weight: ${FontWeight.medium};
`
const Container = styled.div`
  display: flex;
  padding: ${({ theme }) => `${theme.sizes.spacings.xxxl}px 0px`};
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => `${theme.sizes.spacings.md}px`};

  border-radius: ${({ theme }) => `${theme.sizes.borderRadius.sm}px`};
  background: ${({ theme }) => theme.colors.primary.container};
`
export type CompanyHighlight = null | DeepNullable<{
  name: string
  value: string
  description: string
}>
type Props = {
  data: CompanyHighlight
}

export const CompanyHighlightCard = memo(({ data }: Props) => {
  return (
    <Container>
      <Value>{data?.value}</Value>
      <Name>{data?.name}</Name>
      <Description>{data?.description}</Description>
    </Container>
  )
})

CompanyHighlightCard.displayName = 'CompanyHighlightCard'
